// features/drive/components/Toolbar/Toolbar.js

import React from 'react';
import { Grid2X2, List } from 'lucide-react';

import useDrive from '../../hooks/useDrive';
import UploadButton from '../Upload/UploadButton';
import Search from '../Search/Search';

import {
  ToolbarWrapper,
  LeftSection,
  RightSection,
  ViewToggle,
  ToggleButton,
} from './Toolbar.styles';
import { DashboardButton } from '../../../UploadDocuments/uploadDocuments.styles';
import { useNavigate } from 'react-router-dom';

const Toolbar = () => {
  const { view, setView } = useDrive();
  const navigate = useNavigate();

  const handleDashboard = () => navigate('/');

  return (
    <ToolbarWrapper>
      <LeftSection>
        <Search />
      </LeftSection>

      <RightSection>
        <DashboardButton onClick={handleDashboard} type="button">
          Dashboard
        </DashboardButton>
        <ViewToggle>
          <ToggleButton type="button" $active={view === 'table'} onClick={() => setView('table')}>
            <List size={16} />
          </ToggleButton>

          <ToggleButton type="button" $active={view === 'grid'} onClick={() => setView('grid')}>
            <Grid2X2 size={16} />
          </ToggleButton>
        </ViewToggle>

        <UploadButton />
      </RightSection>
    </ToolbarWrapper>
  );
};

export default Toolbar;
